module.exports = __webpack_public_path__ + "img/page_setting_2.b84ae0cf.png";